import SabonnerForm from "../components/sabonner/SabonnerForm";
import Title from "../components/ui/Title";
import { Skeleton } from "../components/ui/skeleton";
import { Alert } from "../components/ui/alert";
import { useAbonnementData, useAllowReabonnement } from "../lib/hooks/useAbonnements";
import { useCurrentUser } from "../lib/hooks/useCurrentUser";
import { Link, Navigate, useLoaderData } from "react-router";
import { useSetAtom } from "jotai";
import { modeDePaiementAtom, packAtom } from "../lib/atoms";
import { useEffect } from "react";
import { ArrowLeftIcon } from "lucide-react";

const SabonnerPage = () => {
  const { type } = useLoaderData() as { type: "papier" | "numerique" };
  const setTypeAssurance = useSetAtom(packAtom);
  const setModeDePaiement = useSetAtom(modeDePaiementAtom);
  const { data: user, isError } = useCurrentUser({
    refetchOnWindowFocus: false,
  });
  const { data: canReabo } = useAllowReabonnement({
    refetchOnWindowFocus: false,
  });
  const { data: sabonnerData, isError: erreurAboData } = useAbonnementData({
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    setTypeAssurance(undefined);
    setModeDePaiement("");
  }, []);

  // Si user pas autorisé à se réabonner, redirect home
  if (canReabo === false) return <Navigate to={"/"} />;

  return (
    <>
      <div className='flex items-center gap-4 mb-6'>
        <Link to='/sabonner'>
          <button className='rounded-full bg-white border p-3 hover:bg-gray-50 active:bg-gray-100'>
            <ArrowLeftIcon />
          </button>
        </Link>
        <Title>S'abonner à l'Abeille de France</Title>
      </div>

      {/* Loading */}
      {(!user || !sabonnerData) && !erreurAboData && !isError && (
        <div className='flex flex-col gap-3'>
          <Skeleton className='w-full h-80' />
          <Skeleton className='w-full h-10' />
          <Skeleton className='w-full h-12' />
          <Skeleton className='w-full h-24' />
          <Skeleton className='w-full h-24' />
          <Skeleton className='w-full h-24' />
        </div>
      )}

      {/* Error */}
      {(isError || erreurAboData) && (
        <Alert variant={"destructive"}>Une erreur s'est produite. Veuillez réessayer ultérieurement.</Alert>
      )}

      {/* Data */}
      {!!user && !!sabonnerData && (
        <SabonnerForm
          type={type}
          civilites={sabonnerData.civilites}
          packs={sabonnerData.packs}
          user={user}
          tarif={sabonnerData.tarif}
        />
      )}
    </>
  );
};

export default SabonnerPage;
